// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DemoContainer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 30px;
}

.switchBox {
  padding: 0 !important;
}

.taskInputBox {
  padding: 10px !important;
  height: 20px;
}
.taskInputBox .taskInput input {
  padding: 5px 20px;
}
.taskInputBox .taskInput label {
  font-size: 14px;
}
.taskInputBox .taskInput label.MuiFormLabel-filled {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.taskInputBox .taskInput label.Mui-focused {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.taskInputBox .taskInput .MuiInputBase-multiline {
  padding: 5px 15px;
}
.taskInputBox div label {
  top: -11px;
  font-size: 14px;
}
.taskInputBox div label.MuiFormLabel-filled {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.taskInputBox div label.Mui-focused {
  top: 4px;
  left: 4px;
  font-size: 12px;
}
.taskInputBox div input {
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 14px;
}
.taskInputBox div fieldset {
  border-radius: 8px;
}
.taskInputBox .select-box-task {
  width: 150px;
}
.taskInputBox .select-box-task div {
  padding-top: 5px;
  padding-bottom: 5px;
}
.taskInputBox textarea {
  width: 200px;
  height: 30px;
  min-width: 200px;
  max-width: 300px;
  min-height: 30px;
  max-height: 700px;
  box-sizing: border-box;
  margin-top: 3px;
  border-radius: 8px;
  border: 1px solid gray;
  background-color: transparent;
  color: white;
  padding: 5px;
  padding-left: 15px;
}
.taskInputBox textarea:disabled {
  color: white;
}
.taskInputBox .deleteTask {
  height: 30px;
  padding: 0;
}

.disabledButWhite div input:disabled {
  color: white;
  -webkit-text-fill-color: white;
  opacity: 1;
}

.mainDivTask .createTaskForm {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
}
.mainDivTask .createTaskForm .datetimepicker {
  width: 100%;
}

.taskAccordion {
  margin: 20px;
}
.taskAccordion .createTaskForm {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 0;
}
.taskAccordion .createTaskForm .datetimepicker {
  width: 100%;
}

.getMainCreateTask {
  max-width: 100vw;
  overflow: hidden;
}
.getMainCreateTask div.MuiPaper-rounded {
  max-width: 100%;
}
.getMainCreateTask .filtrDiv {
  padding: 15px;
  box-sizing: border-box;
}
.getMainCreateTask .commentTextarea {
  width: 200px;
  height: 30px;
  min-width: 200px;
  max-width: 300px;
  min-height: 30px;
  max-height: 700px;
  box-sizing: border-box;
  margin-top: 3px;
  border-radius: 8px;
  border: 1px solid gray;
  background-color: transparent;
  color: white;
  padding: 5px;
  padding-left: 15px;
}

div.Mui-disabled {
  color: #fff !important;
}
div.Mui-disabled input {
  color: #fff !important;
  -webkit-text-fill-color: #fff !important;
}

input.Mui-disabled {
  color: #fff !important;
  -webkit-text-fill-color: #fff !important;
}

input::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

.status-dialog-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
}

.taskTableContainer .MuiCollapse-wrapper {
  overflow: scroll;
}

.tableDataDiv {
  overflow-x: scroll;
  min-height: 100vh;
}
.tableDataDiv table {
  width: 2000px;
}

@media (max-width: 1650px) {
  .filtrDivTask {
    overflow-x: scroll;
    width: 100vw !important;
  }
  .filtrDivTask table {
    width: 1650px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/task/task.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AAFJ;;AAKA;EACI,qBAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,YAAA;AAFJ;AAOQ;EACI,iBAAA;AALZ;AAUQ;EAEI,eAAA;AATZ;AAYQ;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAVZ;AAaQ;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAXZ;AAcQ;EACI,iBAAA;AAZZ;AAkBQ;EACI,UAAA;EACA,eAAA;AAhBZ;AAmBQ;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAjBZ;AAoBQ;EACI,QAAA;EACA,SAAA;EACA,eAAA;AAlBZ;AAsBQ;EACI,gBAtEQ;EAuER,mBAvEQ;EAwER,eAAA;AApBZ;AA0BQ;EACI,kBAAA;AAxBZ;AA4BI;EACI,YAAA;AA1BR;AA4BQ;EACI,gBAvFQ;EAwFR,mBAxFQ;AA8DpB;AA8BI;EACI,YAAA;EACA,YA/FM;EAgGN,gBAAA;EACA,gBAAA;EACA,gBAlGM;EAmGN,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA5BR;AA+BI;EACI,YAAA;AA7BR;AAiCI;EACI,YApHM;EAqHN,UAAA;AA/BR;;AAqCQ;EACI,YAAA;EACA,8BAAA;EACA,UAAA;AAlCZ;;AA0CI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAvCR;AAyCQ;EACI,WAAA;AAvCZ;;AA4CA;EACI,YAAA;AAzCJ;AA2CI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAzCR;AA2CQ;EACI,WAAA;AAzCZ;;AA8CA;EACI,gBAAA;EACA,gBAAA;AA3CJ;AA6CI;EACI,eAAA;AA3CR;AA8CI;EACI,aAAA;EACA,sBAAA;AA5CR;AA+CI;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA7CR;;AAkDA;EACI,sBAAA;AA/CJ;AAiDI;EACI,sBAAA;EACA,wCAAA;AA/CR;;AAmDA;EACI,sBAAA;EACA,wCAAA;AAhDJ;;AAmDA;EACI,iBAAA;AAhDJ;;AAmDA;EACI,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;AAhDJ;;AAoDI;EACI,gBAAA;AAjDR;;AAsDA;EACI,kBAAA;EACA,iBAAA;AAnDJ;AAqDI;EACI,aAAA;AAnDR;;AAyDA;EACI;IACI,kBAAA;IACA,uBAAA;EAtDN;EAwDM;IACI,aAAA;EAtDV;AACF","sourcesContent":["$cell-heigth: 30px;\n$input-t-b-padding: 5px;\n\n.DemoContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 30px;\n}\n\n.switchBox {\n    padding: 0 !important;\n}\n\n.taskInputBox {\n    padding: 10px !important;\n    height: 20px;\n\n    .taskInput {\n\n\n        input {\n            padding: $input-t-b-padding 20px;\n\n        }\n\n\n        label {\n            // top: -5px;\n            font-size: 14px;\n        }\n\n        label.MuiFormLabel-filled {\n            top: 4px;\n            left: 4px;\n            font-size: 12px;\n        }\n\n        label.Mui-focused {\n            top: 4px;\n            left: 4px;\n            font-size: 12px;\n        }\n\n        .MuiInputBase-multiline {\n            padding: $input-t-b-padding 15px;\n        }\n\n    }\n\n    div {\n        label {\n            top: -11px;\n            font-size: 14px;\n        }\n\n        label.MuiFormLabel-filled {\n            top: 4px;\n            left: 4px;\n            font-size: 12px;\n        }\n\n        label.Mui-focused {\n            top: 4px;\n            left: 4px;\n            font-size: 12px;\n        }\n\n\n        input {\n            padding-top: $input-t-b-padding;\n            padding-bottom: $input-t-b-padding;\n            font-size: 14px;\n        }\n\n\n\n\n        fieldset {\n            border-radius: 8px;\n        }\n    }\n\n    .select-box-task {\n        width: 150px;\n\n        div {\n            padding-top: $input-t-b-padding;\n            padding-bottom: $input-t-b-padding;\n        }\n    }\n\n    textarea {\n        width: 200px;\n        height: $cell-heigth;\n        min-width: 200px;\n        max-width: 300px;\n        min-height: $cell-heigth;\n        max-height: 700px;\n        box-sizing: border-box;\n        margin-top: 3px;\n        border-radius: 8px;\n        border: 1px solid gray;\n        background-color: transparent;\n        color: white;\n        padding: 5px;\n        padding-left: 15px;\n    }\n\n    textarea:disabled {\n        color: white;\n    }\n\n\n    .deleteTask {\n        height: $cell-heigth;\n        padding: 0;\n    }\n}\n\n.disabledButWhite {\n    div {\n        input:disabled {\n            color: white;\n            -webkit-text-fill-color: white;\n            opacity: 1;\n        }\n    }\n}\n\n.mainDivTask {\n\n\n    .createTaskForm {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        padding: 20px 0;\n\n        .datetimepicker {\n            width: 100%;\n        }\n    }\n}\n\n.taskAccordion {\n    margin: 20px;\n\n    .createTaskForm {\n        display: flex;\n        flex-direction: column;\n        gap: 20px;\n        padding: 20px 0;\n\n        .datetimepicker {\n            width: 100%;\n        }\n    }\n}\n\n.getMainCreateTask {\n    max-width: 100vw;\n    overflow: hidden;\n\n    div.MuiPaper-rounded {\n        max-width: 100%;\n    }\n\n    .filtrDiv {\n        padding: 15px;\n        box-sizing: border-box;\n    }\n\n    .commentTextarea {\n        width: 200px;\n        height: 30px;\n        min-width: 200px;\n        max-width: 300px;\n        min-height: 30px;\n        max-height: 700px;\n        box-sizing: border-box;\n        margin-top: 3px;\n        border-radius: 8px;\n        border: 1px solid gray;\n        background-color: transparent;\n        color: white;\n        padding: 5px;\n        padding-left: 15px;\n    }\n\n}\n\ndiv.Mui-disabled {\n    color: #fff !important;\n\n    input {\n        color: #fff !important;\n        -webkit-text-fill-color: #fff !important;\n    }\n}\n\ninput.Mui-disabled {\n    color: #fff !important;\n    -webkit-text-fill-color: #fff !important;\n}\n\ninput::-webkit-calendar-picker-indicator {\n    filter: invert(1);\n}\n\n.status-dialog-content {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.taskTableContainer {\n    .MuiCollapse-wrapper {\n        overflow: scroll;\n    }\n}\n\n\n.tableDataDiv {\n    overflow-x: scroll;\n    min-height: 100vh;\n\n    table {\n        width: 2000px;\n    }\n\n}\n\n\n@media (max-width: 1650px) {\n    .filtrDivTask {\n        overflow-x: scroll;\n        width: 100vw !important;\n\n        table {\n            width: 1650px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
